import { useMutation } from "@tanstack/react-query";
import graphqlClient from '@/graphql/graphql-client';

import type { UpdateOrganizationMutation, UpdateOrganizationMutationVariables } from '@/graphql/generated/graphql';
import { UpdateOrganizationDocument } from '@/graphql/generated/graphql';
export type UpdateOrganizationPayload = {
  itemId: string
  Name?: string
  Slug?: string
  LogoUrl?: string
  MaxUsers?: number
  MaxTemplates?: number
  SeliseClientId?: string
  SeliseClientSecret?: string
  BlocksOrgId?: string
  SigOrgId?: string
}

export type UpdateOrganizationResponse = {
  acknowledged: boolean
  itemId: string
  totalImpactedData: number
  message?: string | null
}

export const useUpdateOrganization = () => {
  const mutation = useMutation({
    mutationKey: ['update-organization'],
    mutationFn: (variables: UpdateOrganizationPayload) => {
      return graphqlClient.request<UpdateOrganizationMutation>(UpdateOrganizationDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateOrganization: mutation.mutate,
    updateOrganizationAsync: mutation.mutateAsync,
  }
}

export const UPDATE_ORGANIZATION_MUTATION = UpdateOrganizationDocument;
